/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_User_Already_Has_PasswordInputs */

const nl_auth_password_errors_user_already_has_password = /** @type {(inputs: Auth_Password_Errors_User_Already_Has_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gebruiker heeft al een wachtwoord ingesteld`)
};

/**

* @param {Auth_Password_Errors_User_Already_Has_PasswordInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_user_already_has_password = /** @type {((inputs?: Auth_Password_Errors_User_Already_Has_PasswordInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_User_Already_Has_PasswordInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_user_already_has_password(inputs)
});
export { auth_password_errors_user_already_has_password as "auth.password_errors.user_already_has_password" }